export class UserToLogin{
    username?: string;
    password?: string;
    defaultConfiguration?: string;
}